import React from "react";
import {
    formatAEMCashPrice,
    hasDualCurrency,
} from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import type { PriceType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../../redux/store";

import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import { hideDiscountInfo } from "../../../../../../../common-deprecated/priceUtils";
import PricePromoIcon from "../../common/price/PricePromoIcon";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { getBnbPriceConfig } from "../../../../utils/settings/bnbFinanceSettingUtils";

export type CashPricePropsType = {
    price: PriceType;
};

const CashPrice = ({ price }: CashPricePropsType): JSX.Element | null => {
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const modelCode = useBnbSelector((state) => state.car?.model?.internalCode || "");

    const hasSecondaryPrice = useBnbSelector((state) => hasDualCurrency(state.commonSettings));
    const priceConfig = getBnbPriceConfig(commonSettings, modelCode, NavStep.Model);

    const { highlight, discount, cash, promotions, licenseFee } = price;
    const cultureName = commonSettings.culture.name;

    if (!cash || !priceConfig.priceEnabled) return null;
    const hideDiscount = hideDiscountInfo(priceConfig);

    // Highlight is also a type of promotion which does not alter the price but should show the text as highlighted.
    if ((highlight || discount !== cash || promotions.length > 0) && !hideDiscount) {
        const cashFormatted = formatAEMCashPrice(cash, cultureName, priceConfig);
        const discountFormatted = formatAEMCashPrice(discount, cultureName, priceConfig, licenseFee);
        return (
            <Styles.PricesWrapper>
                <div>
                    <Styles.Text
                        dangerouslySetInnerHTML={{ __html: discountFormatted }}
                        isLarge={discount !== cash || promotions.length > 0}
                        mt={2}
                    />
                    {promotions.length > 0 && <PricePromoIcon promotions={promotions} />}
                </div>

                {!highlight && discount !== cash && (
                    <Styles.TextLineThrough dangerouslySetInnerHTML={{ __html: cashFormatted }} fontSize="13px" />
                )}
            </Styles.PricesWrapper>
        );
    }

    return (
        <Styles.PricesWrapper>
            <Styles.Text
                dangerouslySetInnerHTML={{
                    __html: formatAEMCashPrice(
                        hideDiscountInfo(priceConfig) ? discount : cash,
                        cultureName,
                        priceConfig,
                        licenseFee,
                        false,
                    ),
                }}
            />
            {/* Dual currency price */}
            {hasSecondaryPrice && (
                <Styles.Text
                    dangerouslySetInnerHTML={{
                        __html: formatAEMCashPrice(
                            hideDiscountInfo(priceConfig) ? discount : cash,
                            cultureName,
                            priceConfig,
                            licenseFee,
                            true,
                        ),
                    }}
                />
            )}
        </Styles.PricesWrapper>
    );
};

export default CashPrice;
